const a = (t, e) => {
  const n = Date.now(), o = Math.floor(Math.random() * 1e3), r = e ? `-${e}` : "";
  return `${t}-${n}-${o}${r}`;
}, $ = (t, e) => a(`${e}-${t}`);
export {
  $ as generateFieldId,
  a as generateUniqueId
};
